import { ACCOUNT_MAIN_CURRENCY } from '@/assets/constants/accounts'

/** saves number of operations to sign
@payload{ Array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_operationssigned
*/
export const SAVE_APPROVALS_TO_SIGN_NUMBER = (state, payload) => {
    state.signListCounter = payload.totalNumberOfOperationsToSign
}

/** saves Home Balances
@payload { Array } - with all accounts info to create home feature, in this case we will only use:
    totalAssetsAvailableBalanceByCurrency {Object} - with balances for each currency
    currenciesFromAccounts {Array} - each object is a currency and has it's info
    accountTypes {Array} - list of accounts types this logged user have
    accounts {Array} - list of accounts for our logged user
*/
export const UPDATE_HOME_PATRIMONY_INFO = (state, payload) => {
    state.patrimonyInfo = payload
    state.homeAccountTypes = payload.accountTypes
    state.homeAccounts = payload.accounts
}

/** saves cards list
@payload { Array }https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_cardsgetCards
*/
export const SAVE_CARDS_LIST = (state, payload) => {
    state.cardsList = payload.map(card => {
        return {
            ...card,
            friendlyName: card.additionalInfoCardView.friendlyName ? card.additionalInfoCardView.friendlyName : ''
        }
    })
}

/** saves accounts list
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accountsbalances
*/
export const SAVE_ACCOUNTS_LIST = (state, payload) => {
    state.accountsList = payload.balanceViews
}

/** saves last na hora transfers list
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_operations
*/
export const SAVE_LAST_NA_HORA_TRANSFERS_LIST = (state, payload) => {
    state.lastNaHoraTransfersList = payload.customerOperations
}

/** saves cashflow info
@payload { Objec }
*/
export const SAVE_CASHFLOW_INFO = (state, payload) => {
    state.cashflowInfo = payload
}

/** saves Home Movements
@payload { Array } - list of movements for selected account
*/
export const SAVE_HOME_MOVEMENTS = (state, payload) => {
    state.homeMovements = payload
}

/** saves exchange table list - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetexchangetable
@payload { object }
*/
export const SAVE_EXCHANGE_TABLE_LIST = (state, payload) => {
    if (payload.exchangeTableEntryViewList) {
        state.exchangeTableList = payload.exchangeTableEntryViewList
        state.lastUpdateDate = payload.lastUpdateDate
    } else {
        state.exchangeTableList = []
        state.lastUpdateDate = null
    }
}

/** saves exchange table with value - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetexchangetablewithvalue
@payload { object }
*/
export const SAVE_EXCHANGE_TABLE_WITH_VALUE = (state, payload) => {
    if (payload.exchangeTableEntryViewList) {
        state.exchangeTableWithValue = payload.exchangeTableEntryViewList
        state.lastUpdateDate = payload.lastUpdateDate
    } else {
        state.exchangeTableWithValue = []
        state.lastUpdateDate = null
    }
}

/** saves Dashboard Cards
@payload { Array } - list of cards to display
*/
export const SAVE_DASHBOARD_CARDS = (state, payload) => {
    state.dashboardCards = payload
}

/** saves TPAs List
@payload { Array } - list of tpas requested
*/
export const SAVE_TPAS_LIST = (state, payload) => {
    state.tpasList = payload
}

/** saves Operators List
@payload { Array } - list of operators
*/
export const SAVE_OPERATORS_LIST = (state, payload) => {
    state.operatorsList = payload
}

/** saves frequent operations
@payload { Array } - list of frequent operations
*/
export const SAVE_FREQUENT_OPERATIONS = (state, payload) => {
    state.frequentOperations = payload
}

/* ***********************************************
*                  CLEAR MUTATIONS               *
*********************************************** */
export const CLEAR_FEATURE_STATE = (state, payload) => {
    state.homeBalances = []
    state.selectedCurrency = null
    state.cardsList = []
    state.accountsList = []
    state.cashflowInfo = null
    state.homeMovements = []
    /* Exchanges states */
    state.exchangeTableList = []
    state.exchangeTableWithValue = []
    state.lastUpdateDate = null
    /* Fast Links */
    state.dashboardCards = []
    /* TPAs */
    state.tpasList = []
    /* Operators */
    state.operatorsList = []
}
